/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Financials/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Financials({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Financials",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Financials.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-GhRSO': alignSelf,'--mt-2-GhRSO': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-GhRSO': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-GhRSO': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-GhRSO': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-GhRSO': opacity,'--w-10-GhRSO': typeof width === 'number' ? `${width}px` : width,'--h-11-GhRSO': typeof height === 'number' ? `${height}px` : height,'--f-12-GhRSO': fill,'--a-7-GhRSO': isAnimated ? animation : "none",'--sd-8-GhRSO': isAnimated ? strokeDashoffset : 0,'--sd-9-GhRSO': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Financials.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-8.929-5.357a1.071 1.071 0 10-2.143 0v.73a2.666 2.666 0 00-.285 5.253l2.105.46a.715.715 0 01-.153 1.414h-1.19a.715.715 0 01-.674-.476 1.072 1.072 0 00-2.02.714 2.86 2.86 0 002.217 1.865v.754a1.071 1.071 0 102.143 0v-.754a2.859 2.859 0 00.135-5.61l-2.105-.46a.523.523 0 01.112-1.033h1.382a.71.71 0 01.674.476 1.071 1.071 0 002.02-.714 2.856 2.856 0 00-2.218-1.865v-.754z"
 style={{'--f-12-GhRSO': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}